export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      products: "Products",
      generators: "Generators",
      markets: "Markets",
      about: "About Us",
      contact: "Contact",
      rfq: "Request Quote",
    },
    // Hero
    hero: {
      tagline: "Global Trade Solutions",
      title_line1: "Your",
      title_line2: "Gateway",
      title_line3: "To Markets",
      subtitle: "Agricultural products, building materials, generators, batteries, and industrial equipment from trusted sources worldwide",
      cta_primary: "Explore Products",
      cta_secondary: "Get a Quote",
    },
    // Marquee
    marquee: {
      quality: "Premium Quality",
      network: "Global Network",
      partners: "Trusted Partners",
      delivery: "Fast Delivery",
    },
    // Stats
    stats: {
      countries: "Countries Served",
      products: "Products",
      partners: "Trade Partners",
      experience: "Years Experience",
    },
    // About Section (Home)
    about_section: {
      tagline: "About Us",
      title: "Your Gateway to Global Trade",
      description: "For over 15 years, Varyaz Trade has been the bridge between global suppliers and international buyers. From agricultural commodities to building materials, generators to industrial machinery – we don't just trade products, we build lasting partnerships.",
      trade_volume: "Annual Trade Volume",
      partners: "Global Partners",
      countries: "Countries",
    },
    // Why Choose Us
    why_us: {
      tagline: "Why Partner With Us",
      title: "Why Choose Varyaz Trade",
      subtitle: "Your gateway to global markets",
      quality: {
        title: "Quality Assurance",
        description: "All products undergo rigorous quality checks and come with international certifications"
      },
      global: {
        title: "Global Network",
        description: "Direct connections with suppliers and manufacturers across 50+ countries"
      },
      logistics: {
        title: "Seamless Logistics",
        description: "End-to-end supply chain management from source to destination"
      },
      competitive: {
        title: "Competitive Pricing",
        description: "Bulk purchasing power ensures the best rates for our clients"
      },
      support: {
        title: "24/7 Support",
        description: "Dedicated account managers available around the clock"
      },
      docs: {
        title: "Documentation",
        description: "Complete export documentation and compliance assistance"
      }
    },
    // CTA Section
    cta_section: {
      tagline: "Start Your Journey",
      title: "Ready to Source Quality Products Globally?",
      button: "Get Started",
    },
    // Products
    products: {
      title: "Our Product Categories",
      subtitle: "Explore our comprehensive range of trade commodities",
      view_all: "View All",
      min_order: "Min. Order",
      origin: "Origin",
      certifications: "Certifications",
      specifications: "Specifications",
      request_quote: "Request Quote",
      filter_all: "All Categories",
      search_placeholder: "Search products...",
      showing: "Showing",
      products_label: "products",
      in_category: "in",
      clear: "Clear",
      no_products: "No products found",
      try_adjusting: "Try adjusting your search or filter",
      clear_all: "Clear All Filters",
    },
    // Markets Page
    markets: {
      title: "Commodity Markets",
      subtitle: "Real-time prices & market analysis",
      tab_treemap: "Treemap",
      tab_calendar: "Calendar",
      tab_news: "News",
      filter_all: "All",
      filter_grains: "Grains",
      filter_energy: "Energy",
      filter_metals: "Metals",
      filter_industrial: "Industrial",
      refresh: "Refresh",
      loading: "Loading market data...",
      calendar_title: "Economic Calendar - Next 7 Days",
      calendar_subtitle: "High-impact events affecting commodity markets",
      no_events: "No major commodity events scheduled",
      performance: "Performance",
      tile_size_note: "Tile size = magnitude of change",
    },
    // RFQ
    rfq: {
      title: "Request for Quotation",
      subtitle: "Get competitive prices for bulk orders",
      get_pricing: "Get Competitive Pricing",
      form: {
        product: "Product Name",
        category: "Category",
        quantity: "Quantity",
        unit: "Unit",
        destination: "Destination Port",
        company: "Company Name",
        contact: "Contact Person",
        email: "Email Address",
        phone: "Phone Number",
        message: "Additional Requirements",
        submit: "Submit Request",
        success: "Your request has been submitted successfully!",
        error: "Something went wrong. Please try again.",
      },
      units: {
        mt: "Metric Tons",
        kg: "Kilograms",
        units: "Units",
        containers: "Containers (20ft/40ft)",
      }
    },
    // About
    about: {
      title: "About Varyaz Trade",
      subtitle: "Your Gateway to Global Markets",
      story: {
        title: "Our Story",
        content: "Founded with a vision to simplify international trade, Varyaz Trade has grown into a trusted B2B trading platform. We connect suppliers, manufacturers, and buyers across continents, ensuring quality products in trade commodities, building materials, power equipment, and industrial machinery reach destinations worldwide."
      },
      mission: {
        title: "Our Mission",
        content: "To facilitate seamless global trade while ensuring competitive prices for buyers and reliable partnerships for suppliers."
      },
      vision: {
        title: "Our Vision",
        content: "To become the world's most trusted platform for B2B commodity trading, empowering businesses across all industries."
      },
      values: {
        title: "Our Values",
        integrity: "Integrity",
        integrity_desc: "Transparent dealings in every transaction",
        quality: "Quality",
        quality_desc: "Only certified products make it to our catalog",
        partnership: "Partnership",
        partnership_desc: "Long-term relationships over quick profits",
        innovation: "Innovation",
        innovation_desc: "Embracing technology for better trade"
      }
    },
    // Contact
    contact: {
      title: "Contact Us",
      subtitle: "Get in touch with our team",
      get_in_touch: "Get In Touch",
      form: {
        name: "Your Name",
        email: "Email Address",
        company: "Company Name",
        subject: "Subject",
        message: "Your Message",
        submit: "Send Message",
        success: "Message sent successfully!",
        error: "Failed to send message. Please try again.",
      },
      info: {
        address: "Address",
        address_value: "Dnipro, Ukraine",
        phone: "WhatsApp",
        phone_value: "+90 537 702 09 27",
        email: "Email",
        email_value: "info@varyaztrade.com",
        hours: "Business Hours",
        hours_value: "Mon - Fri: 9:00 AM - 6:00 PM",
      }
    },
    // Footer
    footer: {
      description: "Your trusted partner in global B2B trading. Connecting suppliers to markets worldwide.",
      quick_links: "Quick Links",
      categories: "Categories",
      contact: "Contact",
      newsletter: "Newsletter",
      newsletter_placeholder: "Enter your email",
      subscribe: "Subscribe",
      rights: "All rights reserved.",
      address: "Dnipro, Ukraine",
      cta_title: "Ready to Start Trading?",
      cta_subtitle: "Get competitive prices for bulk orders",
      get_quote: "Get a Quote",
      privacy: "Privacy",
      terms: "Terms",
      cat_rice: "Rice & Grains",
      cat_steel: "Steel & Metals",
      cat_generators: "Generators",
      cat_batteries: "Batteries",
      cat_tiles: "Tiles & Flooring",
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      back: "Back",
      learn_more: "Learn More",
    },
    // Admin
    admin: {
      title: "Admin Dashboard",
      analytics: "Analytics",
      inquiries: "Inquiries",
      total_visits: "Total Visits",
      page_views: "Page Views",
      rfq_submissions: "RFQ Submissions",
      contact_submissions: "Contact Messages",
      recent_rfqs: "Recent Quote Requests",
      recent_contacts: "Recent Contact Messages",
      no_data: "No data available",
      view_all: "View All",
      status: "Status",
      pending: "Pending",
      responded: "Responded",
      date: "Date",
      product: "Product",
      company: "Company",
      email: "Email",
    }
  },
  uk: {
    nav: {
      home: "Головна",
      products: "Продукція",
      generators: "Генератори",
      markets: "Ринки",
      about: "Про нас",
      contact: "Контакти",
      rfq: "Запит ціни",
    },
    hero: {
      tagline: "Глобальні торгові рішення",
      title_line1: "Ваш",
      title_line2: "Шлях",
      title_line3: "До Ринків",
      subtitle: "Преміальні зернові, бобові, спеції та сільськогосподарська техніка з надійних джерел по всьому світу",
      cta_primary: "Переглянути продукцію",
      cta_secondary: "Отримати ціну",
    },
    marquee: {
      quality: "Преміум якість",
      network: "Глобальна мережа",
      partners: "Надійні партнери",
      delivery: "Швидка доставка",
    },
    stats: {
      countries: "Країн обслуговуємо",
      products: "Продуктів",
      partners: "Торгових партнерів",
      experience: "Років досвіду",
    },
    about_section: {
      tagline: "Про нас",
      title: "Ваш шлях до глобальної торгівлі",
      description: "Понад 15 років Varyaz Trade є мостом між глобальними постачальниками та міжнародними покупцями. Від сільськогосподарських товарів до будівельних матеріалів, генераторів до промислового обладнання – ми не просто торгуємо продуктами, ми будуємо тривалі партнерства.",
      trade_volume: "Річний обсяг торгівлі",
      partners: "Глобальні партнери",
      countries: "Країни",
    },
    why_us: {
      tagline: "Чому обрати нас",
      title: "Чому Varyaz Trade",
      subtitle: "Ваш надійний партнер у глобальній торгівлі",
      quality: {
        title: "Гарантія якості",
        description: "Вся продукція проходить суворий контроль якості та має міжнародні сертифікати"
      },
      global: {
        title: "Глобальна мережа",
        description: "Прямі зв'язки з фермерами та виробниками у 50+ країнах"
      },
      logistics: {
        title: "Безперебійна логістика",
        description: "Повне управління ланцюгом постачання від ферми до порту"
      },
      competitive: {
        title: "Конкурентні ціни",
        description: "Оптові закупівлі забезпечують найкращі ціни для наших клієнтів"
      },
      support: {
        title: "Підтримка 24/7",
        description: "Виділені менеджери доступні цілодобово"
      },
      docs: {
        title: "Документація",
        description: "Повна експортна документація та допомога з відповідністю"
      }
    },
    products: {
      title: "Категорії продукції",
      subtitle: "Досліджуйте наш широкий асортимент сільськогосподарських товарів",
      view_all: "Переглянути все",
      min_order: "Мін. замовлення",
      origin: "Походження",
      certifications: "Сертифікати",
      specifications: "Характеристики",
      request_quote: "Запит ціни",
      filter_all: "Всі категорії",
      search_placeholder: "Пошук продукції...",
      showing: "Показано",
      products_label: "продуктів",
      in_category: "в категорії",
      clear: "Очистити",
      no_products: "Продукти не знайдено",
      try_adjusting: "Спробуйте змінити пошук або фільтр",
      clear_all: "Очистити всі фільтри",
    },
    rfq: {
      title: "Запит на котирування",
      subtitle: "Отримайте конкурентні ціни на оптові замовлення",
      get_pricing: "Отримайте конкурентні ціни",
      form: {
        product: "Назва продукту",
        category: "Категорія",
        quantity: "Кількість",
        unit: "Одиниця",
        destination: "Порт призначення",
        company: "Назва компанії",
        contact: "Контактна особа",
        email: "Електронна пошта",
        phone: "Телефон",
        message: "Додаткові вимоги",
        submit: "Надіслати запит",
        success: "Ваш запит успішно надіслано!",
        error: "Щось пішло не так. Спробуйте ще раз.",
      },
      units: {
        mt: "Метричні тонни",
        kg: "Кілограми",
        units: "Одиниці",
        containers: "Контейнери (20ft/40ft)",
      }
    },
    about: {
      title: "Про Varyaz Trade",
      subtitle: "Лідируємо у майбутньому аграрної торгівлі",
      story: {
        title: "Наша історія",
        content: "Заснована з метою подолання розриву між сільськогосподарськими виробниками та глобальними ринками, Varyaz Trade стала надійним ім'ям у торгівлі товарами."
      },
      mission: {
        title: "Наша місія",
        content: "Сприяти безперешкодній глобальній торгівлі сільськогосподарськими товарами, забезпечуючи справедливі ціни для виробників та якісну продукцію для покупців."
      },
      vision: {
        title: "Наше бачення",
        content: "Стати найнадійнішою у світі платформою для торгівлі сільськогосподарськими товарами."
      },
      values: {
        title: "Наші цінності",
        integrity: "Чесність",
        integrity_desc: "Прозорі відносини в кожній угоді",
        quality: "Якість",
        quality_desc: "Тільки найкращі продукти потрапляють до нашого каталогу",
        partnership: "Партнерство",
        partnership_desc: "Довгострокові відносини важливіші за швидкий прибуток",
        innovation: "Інновації",
        innovation_desc: "Використання технологій для кращої торгівлі"
      }
    },
    contact: {
      title: "Зв'яжіться з нами",
      subtitle: "Зв'яжіться з нашою командою",
      get_in_touch: "Зв'яжіться з нами",
      form: {
        name: "Ваше ім'я",
        email: "Електронна пошта",
        company: "Назва компанії",
        subject: "Тема",
        message: "Ваше повідомлення",
        submit: "Надіслати",
        success: "Повідомлення успішно надіслано!",
        error: "Не вдалося надіслати. Спробуйте ще раз.",
      },
      info: {
        address: "Адреса",
        address_value: "Global Trade Center, Дубай, ОАЕ",
        phone: "Телефон",
        phone_value: "+971 4 123 4567",
        email: "Пошта",
        email_value: "info@varyaztrade.com",
        hours: "Робочі години",
        hours_value: "Пн - Пт: 9:00 - 18:00 (GST)",
      }
    },
    footer: {
      description: "Ваш надійний партнер у глобальній торгівлі сільськогосподарськими товарами.",
      quick_links: "Швидкі посилання",
      categories: "Категорії",
      contact: "Контакти",
      newsletter: "Розсилка",
      newsletter_placeholder: "Введіть email",
      subscribe: "Підписатися",
      rights: "Всі права захищені.",
      address: "Дніпро, Україна",
      cta_title: "Готові почати торгівлю?",
      cta_subtitle: "Отримайте конкурентні ціни на оптові замовлення",
      get_quote: "Отримати ціну",
      privacy: "Конфіденційність",
      terms: "Умови",
      cat_rice: "Рис та зернові",
      cat_steel: "Сталь та метали",
      cat_generators: "Генератори",
      cat_batteries: "Акумулятори",
      cat_tiles: "Плитка та підлога",
    },
    common: {
      loading: "Завантаження...",
      error: "Помилка",
      back: "Назад",
      learn_more: "Дізнатися більше",
    },
    admin: {
      title: "Панель адміністратора",
      analytics: "Аналітика",
      inquiries: "Запити",
      total_visits: "Всього відвідувань",
      page_views: "Перегляди сторінок",
      rfq_submissions: "Запити на котирування",
      contact_submissions: "Контактні повідомлення",
      recent_rfqs: "Останні запити",
      recent_contacts: "Останні повідомлення",
      no_data: "Дані відсутні",
      view_all: "Переглянути все",
      status: "Статус",
      pending: "Очікує",
      responded: "Відповіли",
      date: "Дата",
      product: "Продукт",
      company: "Компанія",
      email: "Пошта",
    },
    cta_section: {
      tagline: "Почніть свою подорож",
      title: "Готові закуповувати якісну продукцію глобально?",
      button: "Почати",
    },
    markets: {
      title: "Товарні ринки",
      subtitle: "Ціни в реальному часі та аналіз ринку",
      tab_treemap: "Карта",
      tab_calendar: "Календар",
      tab_news: "Новини",
      filter_all: "Всі",
      filter_grains: "Зернові",
      filter_energy: "Енергія",
      filter_metals: "Метали",
      filter_industrial: "Промислові",
      refresh: "Оновити",
      loading: "Завантаження даних ринку...",
      calendar_title: "Економічний календар - Наступні 7 днів",
      calendar_subtitle: "Важливі події, що впливають на товарні ринки",
      no_events: "Немає запланованих важливих товарних подій",
      performance: "Продуктивність",
      tile_size_note: "Розмір плитки = величина зміни",
    }
  },
  tr: {
    nav: {
      home: "Ana Sayfa",
      products: "Ürünler",
      generators: "Jeneratörler",
      markets: "Piyasalar",
      about: "Hakkımızda",
      contact: "İletişim",
      rfq: "Teklif Al",
    },
    hero: {
      tagline: "Küresel Ticaret Çözümleri",
      title_line1: "Sizin",
      title_line2: "Kapınız",
      title_line3: "Piyasalara",
      subtitle: "Dünya genelinde güvenilir kaynaklardan premium tahıllar, bakliyat, baharatlar ve tarım makineleri",
      cta_primary: "Ürünleri İncele",
      cta_secondary: "Teklif Al",
    },
    stats: {
      countries: "Hizmet Verilen Ülke",
      products: "Ürün",
      partners: "Ticaret Ortağı",
      experience: "Yıllık Deneyim",
    },
    about_section: {
      tagline: "Hakkımızda",
      title: "Küresel Ticarete Kapınız",
      description: "15 yılı aşkın süredir Varyaz Trade, küresel tedarikçiler ile uluslararası alıcılar arasında köprü olmuştur. Tarımsal emtialardan inşaat malzemelerine, jeneratörlerden endüstriyel makinelere – biz sadece ürün ticareti yapmıyoruz, kalıcı ortaklıklar kuruyoruz.",
      trade_volume: "Yıllık Ticaret Hacmi",
      partners: "Küresel Ortaklar",
      countries: "Ülkeler",
    },
    why_us: {
      tagline: "Neden Bizi Tercih Etmelisiniz",
      title: "Neden Varyaz Trade",
      subtitle: "Küresel tarım ticaretinde güvenilir ortağınız",
      quality: {
        title: "Kalite Güvencesi",
        description: "Tüm ürünler sıkı kalite kontrollerinden geçer ve uluslararası sertifikalara sahiptir"
      },
      global: {
        title: "Küresel Ağ",
        description: "50'den fazla ülkede çiftçiler ve üreticilerle doğrudan bağlantılar"
      },
      logistics: {
        title: "Sorunsuz Lojistik",
        description: "Çiftlikten limana uçtan uca tedarik zinciri yönetimi"
      },
      competitive: {
        title: "Rekabetçi Fiyatlar",
        description: "Toplu satın alma gücü müşterilerimiz için en iyi fiyatları sağlar"
      },
      support: {
        title: "7/24 Destek",
        description: "Özel hesap yöneticileri günün her saati hizmetinizde"
      },
      docs: {
        title: "Belgelendirme",
        description: "Eksiksiz ihracat belgeleri ve uyum desteği"
      }
    },
    cta_section: {
      tagline: "Yolculuğunuza Başlayın",
      title: "Küresel Olarak Kaliteli Ürünler Tedarik Etmeye Hazır mısınız?",
      button: "Başlayın",
    },
    markets: {
      title: "Emtia Piyasaları",
      subtitle: "Gerçek zamanlı fiyatlar ve piyasa analizi",
      tab_treemap: "Harita",
      tab_calendar: "Takvim",
      tab_news: "Haberler",
      filter_all: "Tümü",
      filter_grains: "Tahıllar",
      filter_energy: "Enerji",
      filter_metals: "Metaller",
      filter_industrial: "Endüstriyel",
      refresh: "Yenile",
      loading: "Piyasa verileri yükleniyor...",
      calendar_title: "Ekonomik Takvim - Önümüzdeki 7 Gün",
      calendar_subtitle: "Emtia piyasalarını etkileyen yüksek etkili olaylar",
      no_events: "Planlanan önemli emtia olayı yok",
      performance: "Performans",
      tile_size_note: "Döşeme boyutu = değişim büyüklüğü",
    },
    marquee: {
      quality: "Premium Kalite",
      network: "Küresel Ağ",
      partners: "Güvenilir Ortaklar",
      delivery: "Hızlı Teslimat",
    },
    products: {
      title: "Ürün Kategorilerimiz",
      subtitle: "Kapsamlı tarımsal emtia yelpazemizi keşfedin",
      view_all: "Tümünü Gör",
      min_order: "Min. Sipariş",
      origin: "Menşei",
      certifications: "Sertifikalar",
      specifications: "Özellikler",
      request_quote: "Teklif İste",
      filter_all: "Tüm Kategoriler",
      search_placeholder: "Ürün ara...",
      showing: "Gösterilen",
      products_label: "ürün",
      in_category: "kategorisinde",
      clear: "Temizle",
      no_products: "Ürün bulunamadı",
      try_adjusting: "Aramayı veya filtreyi değiştirmeyi deneyin",
      clear_all: "Tüm Filtreleri Temizle",
    },
    rfq: {
      title: "Teklif Talebi",
      subtitle: "Toplu siparişler için rekabetçi fiyatlar alın",
      get_pricing: "Rekabetçi Fiyatlar Alın",
      form: {
        product: "Ürün Adı",
        category: "Kategori",
        quantity: "Miktar",
        unit: "Birim",
        destination: "Varış Limanı",
        company: "Şirket Adı",
        contact: "İlgili Kişi",
        email: "E-posta Adresi",
        phone: "Telefon Numarası",
        message: "Ek Gereksinimler",
        submit: "Talep Gönder",
        success: "Talebiniz başarıyla gönderildi!",
        error: "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",
      },
      units: {
        mt: "Metrik Ton",
        kg: "Kilogram",
        units: "Adet",
        containers: "Konteyner (20ft/40ft)",
      }
    },
    about: {
      title: "Varyaz Trade Hakkında",
      subtitle: "Tarım ticaretinin geleceğine öncülük ediyoruz",
      story: {
        title: "Hikayemiz",
        content: "Tarım üreticileri ile küresel pazarlar arasındaki boşluğu doldurmak vizyonuyla kurulan Varyaz Trade, emtia ticaretinde güvenilir bir isim haline geldi."
      },
      mission: {
        title: "Misyonumuz",
        content: "Üreticiler için adil fiyatlar ve alıcılar için kaliteli ürünler sağlarken küresel tarım ticaretini kolaylaştırmak."
      },
      vision: {
        title: "Vizyonumuz",
        content: "Tarımsal emtia ticareti için dünyanın en güvenilir platformu olmak."
      },
      values: {
        title: "Değerlerimiz",
        integrity: "Dürüstlük",
        integrity_desc: "Her işlemde şeffaf ilişkiler",
        quality: "Kalite",
        quality_desc: "Yalnızca en iyi ürünler kataloğumuza girer",
        partnership: "Ortaklık",
        partnership_desc: "Hızlı kâr yerine uzun vadeli ilişkiler",
        innovation: "Yenilikçilik",
        innovation_desc: "Daha iyi ticaret için teknolojiyi kucaklama"
      }
    },
    contact: {
      title: "Bize Ulaşın",
      subtitle: "Ekibimizle iletişime geçin",
      get_in_touch: "İletişime Geçin",
      form: {
        name: "Adınız",
        email: "E-posta Adresi",
        company: "Şirket Adı",
        subject: "Konu",
        message: "Mesajınız",
        submit: "Mesaj Gönder",
        success: "Mesaj başarıyla gönderildi!",
        error: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
      },
      info: {
        address: "Adres",
        address_value: "Global Trade Center, Dubai, BAE",
        phone: "Telefon",
        phone_value: "+971 4 123 4567",
        email: "E-posta",
        email_value: "info@varyaztrade.com",
        hours: "Çalışma Saatleri",
        hours_value: "Pzt - Cum: 09:00 - 18:00 (GST)",
      }
    },
    footer: {
      description: "Küresel tarımsal emtia ticaretinde güvenilir ortağınız.",
      quick_links: "Hızlı Bağlantılar",
      categories: "Kategoriler",
      contact: "İletişim",
      newsletter: "Bülten",
      newsletter_placeholder: "E-postanızı girin",
      subscribe: "Abone Ol",
      rights: "Tüm hakları saklıdır.",
      address: "Dnipro, Ukrayna",
      cta_title: "Ticarete Başlamaya Hazır mısınız?",
      cta_subtitle: "Toplu siparişler için rekabetçi fiyatlar alın",
      get_quote: "Teklif Al",
      privacy: "Gizlilik",
      terms: "Şartlar",
      cat_rice: "Pirinç ve Tahıllar",
      cat_steel: "Çelik ve Metaller",
      cat_generators: "Jeneratörler",
      cat_batteries: "Aküler",
      cat_tiles: "Fayans ve Döşeme",
    },
    common: {
      loading: "Yükleniyor...",
      error: "Hata",
      back: "Geri",
      learn_more: "Daha Fazla",
    },
    admin: {
      title: "Yönetim Paneli",
      analytics: "Analitik",
      inquiries: "Talepler",
      total_visits: "Toplam Ziyaret",
      page_views: "Sayfa Görüntüleme",
      rfq_submissions: "Teklif Talepleri",
      contact_submissions: "İletişim Mesajları",
      recent_rfqs: "Son Talepler",
      recent_contacts: "Son Mesajlar",
      no_data: "Veri bulunamadı",
      view_all: "Tümünü Gör",
      status: "Durum",
      pending: "Bekliyor",
      responded: "Yanıtlandı",
      date: "Tarih",
      product: "Ürün",
      company: "Şirket",
      email: "E-posta",
    }
  },
  ar: {
    nav: {
      home: "الرئيسية",
      products: "المنتجات",
      generators: "المولدات",
      markets: "الأسواق",
      about: "من نحن",
      contact: "اتصل بنا",
      rfq: "طلب عرض سعر",
    },
    hero: {
      tagline: "حلول التجارة العالمية",
      title_line1: "بوابتك",
      title_line2: "إلى",
      title_line3: "الأسواق",
      subtitle: "حبوب وبقوليات وتوابل وآلات زراعية عالية الجودة من مصادر موثوقة حول العالم",
      cta_primary: "استعرض المنتجات",
      cta_secondary: "احصل على عرض سعر",
    },
    marquee: {
      quality: "جودة ممتازة",
      network: "شبكة عالمية",
      partners: "شركاء موثوقون",
      delivery: "توصيل سريع",
    },
    stats: {
      countries: "دولة نخدمها",
      products: "منتج",
      partners: "شريك تجاري",
      experience: "سنة خبرة",
    },
    about_section: {
      tagline: "من نحن",
      title: "بوابتك إلى التجارة العالمية",
      description: "لأكثر من 15 عامًا، كانت Varyaz Trade الجسر بين الموردين العالميين والمشترين الدوليين. من السلع الزراعية إلى مواد البناء، من المولدات إلى الآلات الصناعية - نحن لا نتاجر بالمنتجات فحسب، بل نبني شراكات دائمة.",
      trade_volume: "حجم التجارة السنوي",
      partners: "الشركاء العالميون",
      countries: "الدول",
    },
    why_us: {
      tagline: "لماذا نحن",
      title: "لماذا Varyaz Trade",
      subtitle: "شريكك الموثوق في التجارة الزراعية العالمية",
      quality: {
        title: "ضمان الجودة",
        description: "جميع المنتجات تخضع لفحوصات جودة صارمة وتحمل شهادات دولية"
      },
      global: {
        title: "شبكة عالمية",
        description: "اتصالات مباشرة مع المزارعين والمصنعين في أكثر من 50 دولة"
      },
      logistics: {
        title: "لوجستيات سلسة",
        description: "إدارة سلسلة التوريد من المزرعة إلى الميناء"
      },
      competitive: {
        title: "أسعار تنافسية",
        description: "قوة الشراء بالجملة تضمن أفضل الأسعار لعملائنا"
      },
      support: {
        title: "دعم على مدار الساعة",
        description: "مدراء حسابات مخصصون متاحون على مدار الساعة"
      },
      docs: {
        title: "التوثيق",
        description: "وثائق تصدير كاملة ومساعدة في الامتثال"
      }
    },
    cta_section: {
      tagline: "ابدأ رحلتك",
      title: "هل أنت مستعد للحصول على منتجات عالية الجودة عالميًا؟",
      button: "ابدأ الآن",
    },
    markets: {
      title: "أسواق السلع",
      subtitle: "الأسعار في الوقت الفعلي وتحليل السوق",
      tab_treemap: "الخريطة",
      tab_calendar: "التقويم",
      tab_news: "الأخبار",
      filter_all: "الكل",
      filter_grains: "الحبوب",
      filter_energy: "الطاقة",
      filter_metals: "المعادن",
      filter_industrial: "الصناعية",
      refresh: "تحديث",
      loading: "جاري تحميل بيانات السوق...",
      calendar_title: "التقويم الاقتصادي - الأيام السبعة القادمة",
      calendar_subtitle: "أحداث عالية التأثير على أسواق السلع",
      no_events: "لا توجد أحداث سلع رئيسية مجدولة",
      performance: "الأداء",
      tile_size_note: "حجم البلاط = حجم التغيير",
    },
    products: {
      title: "فئات منتجاتنا",
      subtitle: "استكشف مجموعتنا الشاملة من السلع الزراعية",
      view_all: "عرض الكل",
      min_order: "الحد الأدنى للطلب",
      origin: "المنشأ",
      certifications: "الشهادات",
      specifications: "المواصفات",
      request_quote: "طلب عرض سعر",
      filter_all: "جميع الفئات",
      search_placeholder: "البحث عن المنتجات...",
      showing: "عرض",
      products_label: "منتجات",
      in_category: "في",
      clear: "مسح",
      no_products: "لم يتم العثور على منتجات",
      try_adjusting: "حاول تعديل البحث أو الفلتر",
      clear_all: "مسح جميع الفلاتر",
    },
    rfq: {
      title: "طلب عرض أسعار",
      subtitle: "احصل على أسعار تنافسية للطلبات بالجملة",
      get_pricing: "احصل على أسعار تنافسية",
      form: {
        product: "اسم المنتج",
        category: "الفئة",
        quantity: "الكمية",
        unit: "الوحدة",
        destination: "ميناء الوصول",
        company: "اسم الشركة",
        contact: "الشخص المسؤول",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        message: "متطلبات إضافية",
        submit: "إرسال الطلب",
        success: "تم إرسال طلبك بنجاح!",
        error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      },
      units: {
        mt: "طن متري",
        kg: "كيلوغرام",
        units: "وحدات",
        containers: "حاويات (20/40 قدم)",
      }
    },
    about: {
      title: "عن Varyaz Trade",
      subtitle: "نقود مستقبل التجارة الزراعية",
      story: {
        title: "قصتنا",
        content: "تأسست برؤية لسد الفجوة بين المنتجين الزراعيين والأسواق العالمية، وأصبحت Varyaz Trade اسماً موثوقاً في تجارة السلع."
      },
      mission: {
        title: "مهمتنا",
        content: "تسهيل التجارة الزراعية السلسة عالمياً مع ضمان أسعار عادلة للمنتجين ومنتجات عالية الجودة للمشترين."
      },
      vision: {
        title: "رؤيتنا",
        content: "أن نصبح المنصة الأكثر موثوقية في العالم لتجارة السلع الزراعية."
      },
      values: {
        title: "قيمنا",
        integrity: "النزاهة",
        integrity_desc: "تعاملات شفافة في كل معاملة",
        quality: "الجودة",
        quality_desc: "فقط أفضل المنتجات تصل إلى كتالوجنا",
        partnership: "الشراكة",
        partnership_desc: "علاقات طويلة الأمد أهم من الأرباح السريعة",
        innovation: "الابتكار",
        innovation_desc: "تبني التكنولوجيا لتجارة أفضل"
      }
    },
    contact: {
      title: "اتصل بنا",
      subtitle: "تواصل مع فريقنا",
      get_in_touch: "تواصل معنا",
      form: {
        name: "اسمك",
        email: "البريد الإلكتروني",
        company: "اسم الشركة",
        subject: "الموضوع",
        message: "رسالتك",
        submit: "إرسال الرسالة",
        success: "تم إرسال الرسالة بنجاح!",
        error: "فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى.",
      },
      info: {
        address: "العنوان",
        address_value: "مركز التجارة العالمي، دبي، الإمارات",
        phone: "الهاتف",
        phone_value: "+971 4 123 4567",
        email: "البريد الإلكتروني",
        email_value: "info@varyaztrade.com",
        hours: "ساعات العمل",
        hours_value: "الإثنين - الجمعة: 9:00 ص - 6:00 م",
      }
    },
    footer: {
      description: "شريكك الموثوق في تجارة السلع الزراعية العالمية.",
      quick_links: "روابط سريعة",
      categories: "الفئات",
      contact: "اتصل بنا",
      newsletter: "النشرة الإخبارية",
      newsletter_placeholder: "أدخل بريدك الإلكتروني",
      subscribe: "اشترك",
      rights: "جميع الحقوق محفوظة.",
      address: "دنيبرو، أوكرانيا",
      cta_title: "هل أنت مستعد لبدء التداول؟",
      cta_subtitle: "احصل على أسعار تنافسية للطلبات بالجملة",
      get_quote: "احصل على عرض سعر",
      privacy: "الخصوصية",
      terms: "الشروط",
      cat_rice: "الأرز والحبوب",
      cat_steel: "الفولاذ والمعادن",
      cat_generators: "المولدات",
      cat_batteries: "البطاريات",
      cat_tiles: "البلاط والأرضيات",
    },
    common: {
      loading: "جاري التحميل...",
      error: "خطأ",
      back: "رجوع",
      learn_more: "اعرف المزيد",
    },
    admin: {
      title: "لوحة الإدارة",
      analytics: "التحليلات",
      inquiries: "الاستفسارات",
      total_visits: "إجمالي الزيارات",
      page_views: "مشاهدات الصفحات",
      rfq_submissions: "طلبات الأسعار",
      contact_submissions: "رسائل التواصل",
      recent_rfqs: "آخر الطلبات",
      recent_contacts: "آخر الرسائل",
      no_data: "لا توجد بيانات",
      view_all: "عرض الكل",
      status: "الحالة",
      pending: "قيد الانتظار",
      responded: "تم الرد",
      date: "التاريخ",
      product: "المنتج",
      company: "الشركة",
      email: "البريد الإلكتروني",
    }
  },
  zh: {
    nav: {
      home: "首页",
      products: "产品",
      generators: "发电机",
      markets: "市场",
      about: "关于我们",
      contact: "联系我们",
      rfq: "询价",
    },
    hero: {
      tagline: "全球贸易解决方案",
      title_line1: "您的",
      title_line2: "通往",
      title_line3: "市场之门",
      subtitle: "来自全球可信来源的优质谷物、豆类、香料和农业机械",
      cta_primary: "浏览产品",
      cta_secondary: "获取报价",
    },
    marquee: {
      quality: "优质品质",
      network: "全球网络",
      partners: "可信伙伴",
      delivery: "快速交付",
    },
    stats: {
      countries: "服务国家",
      products: "产品",
      partners: "贸易伙伴",
      experience: "年经验",
    },
    about_section: {
      tagline: "关于我们",
      title: "您的全球贸易之门",
      description: "15年以来，Varyaz Trade一直是全球供应商与国际买家之间的桥梁。从农产品到建材，从发电机到工业机械——我们不仅仅是交易产品，我们建立持久的合作伙伴关系。",
      trade_volume: "年贸易额",
      partners: "全球合作伙伴",
      countries: "国家",
    },
    why_us: {
      tagline: "为什么选择我们",
      title: "为什么选择 Varyaz Trade",
      subtitle: "您在全球农业贸易中的可信赖伙伴",
      quality: {
        title: "质量保证",
        description: "所有产品都经过严格的质量检查并获得国际认证"
      },
      global: {
        title: "全球网络",
        description: "与50多个国家的农民和制造商建立直接联系"
      },
      logistics: {
        title: "无缝物流",
        description: "从农场到港口的端到端供应链管理"
      },
      competitive: {
        title: "有竞争力的价格",
        description: "批量采购能力确保为客户提供最优价格"
      },
      support: {
        title: "全天候支持",
        description: "专属客户经理全天候服务"
      },
      docs: {
        title: "文件服务",
        description: "完整的出口文件和合规协助"
      }
    },
    cta_section: {
      tagline: "开始您的旅程",
      title: "准备好在全球采购优质产品了吗？",
      button: "开始",
    },
    markets: {
      title: "商品市场",
      subtitle: "实时价格和市场分析",
      tab_treemap: "树图",
      tab_calendar: "日历",
      tab_news: "新闻",
      filter_all: "全部",
      filter_grains: "谷物",
      filter_energy: "能源",
      filter_metals: "金属",
      filter_industrial: "工业",
      refresh: "刷新",
      loading: "正在加载市场数据...",
      calendar_title: "经济日历 - 未来7天",
      calendar_subtitle: "影响商品市场的重大事件",
      no_events: "没有预定的重大商品事件",
      performance: "表现",
      tile_size_note: "图块大小 = 变化幅度",
    },
    products: {
      title: "我们的产品类别",
      subtitle: "探索我们全面的农产品系列",
      view_all: "查看全部",
      min_order: "最小订单",
      origin: "产地",
      certifications: "认证",
      specifications: "规格",
      request_quote: "请求报价",
      filter_all: "所有类别",
      search_placeholder: "搜索产品...",
      showing: "显示",
      products_label: "个产品",
      in_category: "在",
      clear: "清除",
      no_products: "未找到产品",
      try_adjusting: "尝试调整搜索或筛选",
      clear_all: "清除所有筛选",
    },
    rfq: {
      title: "询价请求",
      subtitle: "获取批量订单的竞争价格",
      get_pricing: "获取有竞争力的价格",
      form: {
        product: "产品名称",
        category: "类别",
        quantity: "数量",
        unit: "单位",
        destination: "目的港",
        company: "公司名称",
        contact: "联系人",
        email: "电子邮件",
        phone: "电话号码",
        message: "其他要求",
        submit: "提交请求",
        success: "您的请求已成功提交！",
        error: "出现问题，请重试。",
      },
      units: {
        mt: "公吨",
        kg: "公斤",
        units: "件",
        containers: "集装箱 (20/40英尺)",
      }
    },
    about: {
      title: "关于 Varyaz Trade",
      subtitle: "引领农业贸易的未来",
      story: {
        title: "我们的故事",
        content: "Varyaz Trade 以弥合农业生产者与全球市场之间差距的愿景而成立，已成为商品贸易领域的可信赖品牌。"
      },
      mission: {
        title: "我们的使命",
        content: "促进全球农业贸易的无缝进行，同时确保生产者获得公平价格，买家获得优质产品。"
      },
      vision: {
        title: "我们的愿景",
        content: "成为世界上最值得信赖的农产品贸易平台。"
      },
      values: {
        title: "我们的价值观",
        integrity: "诚信",
        integrity_desc: "每笔交易都透明公正",
        quality: "质量",
        quality_desc: "只有最好的产品才能进入我们的目录",
        partnership: "伙伴关系",
        partnership_desc: "长期关系优于快速利润",
        innovation: "创新",
        innovation_desc: "拥抱技术以实现更好的贸易"
      }
    },
    contact: {
      title: "联系我们",
      subtitle: "与我们的团队取得联系",
      get_in_touch: "联系我们",
      form: {
        name: "您的姓名",
        email: "电子邮件",
        company: "公司名称",
        subject: "主题",
        message: "您的留言",
        submit: "发送消息",
        success: "消息发送成功！",
        error: "发送失败，请重试。",
      },
      info: {
        address: "地址",
        address_value: "全球贸易中心，迪拜，阿联酋",
        phone: "电话",
        phone_value: "+971 4 123 4567",
        email: "邮箱",
        email_value: "info@varyaztrade.com",
        hours: "营业时间",
        hours_value: "周一至周五: 9:00 - 18:00 (GST)",
      }
    },
    footer: {
      description: "您在全球农产品贸易中的可信赖伙伴。",
      quick_links: "快速链接",
      categories: "类别",
      contact: "联系方式",
      newsletter: "订阅通讯",
      newsletter_placeholder: "输入您的邮箱",
      subscribe: "订阅",
      rights: "版权所有。",
      address: "第聂伯罗，乌克兰",
      cta_title: "准备开始交易？",
      cta_subtitle: "获取批量订单的竞争价格",
      get_quote: "获取报价",
      privacy: "隐私",
      terms: "条款",
      cat_rice: "大米和谷物",
      cat_steel: "钢铁和金属",
      cat_generators: "发电机",
      cat_batteries: "电池",
      cat_tiles: "瓷砖和地板",
    },
    common: {
      loading: "加载中...",
      error: "错误",
      back: "返回",
      learn_more: "了解更多",
    },
    admin: {
      title: "管理面板",
      analytics: "分析",
      inquiries: "询价",
      total_visits: "总访问量",
      page_views: "页面浏览量",
      rfq_submissions: "报价请求",
      contact_submissions: "联系消息",
      recent_rfqs: "最近请求",
      recent_contacts: "最近消息",
      no_data: "暂无数据",
      view_all: "查看全部",
      status: "状态",
      pending: "待处理",
      responded: "已回复",
      date: "日期",
      product: "产品",
      company: "公司",
      email: "邮箱",
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      products: "Produits",
      generators: "Générateurs",
      markets: "Marchés",
      about: "À propos",
      contact: "Contact",
      rfq: "Demande de devis",
    },
    hero: {
      title: "Commerce mondial de produits agricoles",
      subtitle: "Céréales, légumineuses, épices et machines agricoles de qualité supérieure provenant de sources fiables du monde entier",
      cta_primary: "Explorer les produits",
      cta_secondary: "Obtenir un devis",
    },
    stats: {
      countries: "Pays desservis",
      products: "Produits",
      partners: "Partenaires commerciaux",
      experience: "Années d'expérience",
    },
    why_us: {
      title: "Pourquoi Varyaz Trade",
      subtitle: "Votre partenaire de confiance dans le commerce agricole mondial",
      quality: {
        title: "Assurance qualité",
        description: "Tous les produits subissent des contrôles de qualité rigoureux et sont certifiés internationalement"
      },
      global: {
        title: "Réseau mondial",
        description: "Connexions directes avec des agriculteurs et fabricants dans plus de 50 pays"
      },
      logistics: {
        title: "Logistique fluide",
        description: "Gestion de la chaîne d'approvisionnement de bout en bout, de la ferme au port"
      },
      competitive: {
        title: "Prix compétitifs",
        description: "Notre pouvoir d'achat en gros garantit les meilleurs tarifs pour nos clients"
      },
      support: {
        title: "Support 24/7",
        description: "Gestionnaires de compte dédiés disponibles à tout moment"
      },
      docs: {
        title: "Documentation",
        description: "Documentation d'exportation complète et assistance à la conformité"
      }
    },
    products: {
      title: "Nos catégories de produits",
      subtitle: "Explorez notre gamme complète de produits agricoles",
      view_all: "Voir tout",
      min_order: "Commande min.",
      origin: "Origine",
      certifications: "Certifications",
      specifications: "Spécifications",
      request_quote: "Demander un devis",
      filter_all: "Toutes les catégories",
      search_placeholder: "Rechercher des produits...",
      showing: "Affichage de",
      products_label: "produits",
      in_category: "dans",
      clear: "Effacer",
      no_products: "Aucun produit trouvé",
      try_adjusting: "Essayez d'ajuster votre recherche ou filtre",
      clear_all: "Effacer tous les filtres",
    },
    rfq: {
      title: "Demande de devis",
      subtitle: "Obtenez des prix compétitifs pour les commandes en gros",
      get_pricing: "Obtenez des prix compétitifs",
      form: {
        product: "Nom du produit",
        category: "Catégorie",
        quantity: "Quantité",
        unit: "Unité",
        destination: "Port de destination",
        company: "Nom de l'entreprise",
        contact: "Personne de contact",
        email: "Adresse e-mail",
        phone: "Numéro de téléphone",
        message: "Exigences supplémentaires",
        submit: "Soumettre la demande",
        success: "Votre demande a été soumise avec succès !",
        error: "Une erreur s'est produite. Veuillez réessayer.",
      },
      units: {
        mt: "Tonnes métriques",
        kg: "Kilogrammes",
        units: "Unités",
        containers: "Conteneurs (20/40 pieds)",
      }
    },
    about: {
      title: "À propos d'Varyaz Trade",
      subtitle: "Leader de l'avenir du commerce agricole",
      story: {
        title: "Notre histoire",
        content: "Fondée avec la vision de combler le fossé entre les producteurs agricoles et les marchés mondiaux, Varyaz Trade est devenue un nom de confiance dans le commerce des matières premières."
      },
      mission: {
        title: "Notre mission",
        content: "Faciliter un commerce agricole mondial fluide tout en garantissant des prix équitables pour les producteurs et des produits de qualité pour les acheteurs."
      },
      vision: {
        title: "Notre vision",
        content: "Devenir la plateforme la plus fiable au monde pour le commerce des produits agricoles."
      },
      values: {
        title: "Nos valeurs",
        integrity: "Intégrité",
        integrity_desc: "Des transactions transparentes à chaque échange",
        quality: "Qualité",
        quality_desc: "Seuls les meilleurs produits figurent dans notre catalogue",
        partnership: "Partenariat",
        partnership_desc: "Des relations à long terme plutôt que des profits rapides",
        innovation: "Innovation",
        innovation_desc: "Adopter la technologie pour un meilleur commerce"
      }
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Entrez en contact avec notre équipe",
      get_in_touch: "Nous contacter",
      form: {
        name: "Votre nom",
        email: "Adresse e-mail",
        company: "Nom de l'entreprise",
        subject: "Sujet",
        message: "Votre message",
        submit: "Envoyer le message",
        success: "Message envoyé avec succès !",
        error: "Échec de l'envoi. Veuillez réessayer.",
      },
      info: {
        address: "Adresse",
        address_value: "Global Trade Center, Dubaï, EAU",
        phone: "Téléphone",
        phone_value: "+971 4 123 4567",
        email: "E-mail",
        email_value: "info@varyaztrade.com",
        hours: "Heures d'ouverture",
        hours_value: "Lun - Ven : 9h00 - 18h00 (GST)",
      }
    },
    footer: {
      description: "Votre partenaire de confiance dans le commerce mondial des produits agricoles.",
      quick_links: "Liens rapides",
      categories: "Catégories",
      contact: "Contact",
      newsletter: "Newsletter",
      newsletter_placeholder: "Entrez votre e-mail",
      subscribe: "S'abonner",
      rights: "Tous droits réservés.",
      address: "Dnipro, Ukraine",
      cta_title: "Prêt à commencer le commerce?",
      cta_subtitle: "Obtenez des prix compétitifs pour les commandes en gros",
      get_quote: "Obtenir un devis",
      privacy: "Confidentialité",
      terms: "Conditions",
      cat_rice: "Riz et céréales",
      cat_steel: "Acier et métaux",
      cat_generators: "Générateurs",
      cat_batteries: "Batteries",
      cat_tiles: "Carrelage et revêtement",
    },
    common: {
      loading: "Chargement...",
      error: "Erreur",
      back: "Retour",
      learn_more: "En savoir plus",
    },
    // Admin
    admin: {
      title: "Tableau de bord Admin",
      analytics: "Analytiques",
      inquiries: "Demandes",
      total_visits: "Visites totales",
      page_views: "Pages vues",
      rfq_submissions: "Demandes de devis",
      contact_submissions: "Messages de contact",
      recent_rfqs: "Demandes récentes",
      recent_contacts: "Messages récents",
      no_data: "Aucune donnée",
      view_all: "Voir tout",
      status: "Statut",
      pending: "En attente",
      responded: "Répondu",
      date: "Date",
      product: "Produit",
      company: "Entreprise",
      email: "E-mail",
    },
    // Markets Page
    markets: {
      title: "Marchés des Matières Premières",
      subtitle: "Prix en temps réel et analyse de marché",
      tab_treemap: "Carte",
      tab_calendar: "Calendrier",
      tab_news: "Actualités",
      filter_all: "Tous",
      filter_grains: "Céréales",
      filter_energy: "Énergie",
      filter_metals: "Métaux",
      filter_industrial: "Industriel",
      refresh: "Actualiser",
      loading: "Chargement des données...",
      calendar_title: "Calendrier Économique - 7 Prochains Jours",
      calendar_subtitle: "Événements à fort impact sur les marchés des matières premières",
      no_events: "Aucun événement majeur prévu",
      performance: "Performance",
      tile_size_note: "Taille = amplitude du changement",
    },
    // Hero additions
    hero: {
      tagline: "Solutions de Commerce Mondial",
      title_line1: "Votre",
      title_line2: "Passerelle",
      title_line3: "Vers les Marchés",
      subtitle: "Céréales, légumineuses, épices et machines agricoles de qualité supérieure provenant de sources fiables du monde entier",
      cta_primary: "Explorer les produits",
      cta_secondary: "Obtenir un devis",
    },
    marquee: {
      quality: "Qualité Premium",
      network: "Réseau Mondial",
      partners: "Partenaires de Confiance",
      delivery: "Livraison Rapide",
    },
    about_section: {
      tagline: "À Propos",
      title: "Votre Passerelle vers le Commerce Mondial",
      description: "Depuis plus de 15 ans, Varyaz Trade relie les fournisseurs mondiaux aux acheteurs internationaux. Des produits agricoles aux matériaux de construction, des générateurs aux machines industrielles – nous ne commercons pas seulement des produits, nous construisons des partenariats durables.",
      trade_volume: "Volume Commercial Annuel",
      partners: "Partenaires Mondiaux",
      countries: "Pays",
    },
    why_us: {
      tagline: "Pourquoi Nous Choisir",
      title: "Pourquoi Varyaz Trade",
      subtitle: "Votre passerelle vers les marchés mondiaux",
      quality: {
        title: "Assurance qualité",
        description: "Tous les produits subissent des contrôles de qualité rigoureux et sont certifiés internationalement"
      },
      global: {
        title: "Réseau mondial",
        description: "Connexions directes avec des agriculteurs et fabricants dans plus de 50 pays"
      },
      logistics: {
        title: "Logistique fluide",
        description: "Gestion de la chaîne d'approvisionnement de bout en bout, de la ferme au port"
      },
      competitive: {
        title: "Prix compétitifs",
        description: "Notre pouvoir d'achat en gros garantit les meilleurs tarifs pour nos clients"
      },
      support: {
        title: "Support 24/7",
        description: "Gestionnaires de compte dédiés disponibles à tout moment"
      },
      docs: {
        title: "Documentation",
        description: "Documentation d'exportation complète et assistance à la conformité"
      }
    },
    cta_section: {
      tagline: "Commencez Votre Parcours",
      title: "Prêt à Sourcer des Produits de Qualité Mondialement?",
      button: "Commencer",
    },
  },
  // Portuguese
  pt: {
    nav: {
      home: "Início",
      products: "Produtos",
      generators: "Geradores",
      markets: "Mercados",
      about: "Sobre Nós",
      contact: "Contato",
      rfq: "Solicitar Cotação",
    },
    hero: {
      tagline: "Soluções de Comércio Global",
      title_line1: "Sua",
      title_line2: "Porta",
      title_line3: "Para os Mercados",
      subtitle: "Produtos agrícolas, materiais de construção, geradores, baterias e equipamentos industriais de fontes confiáveis em todo o mundo",
      cta_primary: "Explorar Produtos",
      cta_secondary: "Obter Cotação",
    },
    marquee: {
      quality: "Qualidade Premium",
      network: "Rede Global",
      partners: "Parceiros Confiáveis",
      delivery: "Entrega Rápida",
    },
    stats: {
      countries: "Países Atendidos",
      products: "Produtos",
      partners: "Parceiros Comerciais",
      experience: "Anos de Experiência",
    },
    about_section: {
      tagline: "Sobre Nós",
      title: "Sua Porta para o Comércio Global",
      description: "Por mais de 15 anos, a Varyaz Trade tem sido a ponte entre fornecedores globais e compradores internacionais. De commodities agrícolas a materiais de construção, geradores a máquinas industriais – não apenas comercializamos produtos, construímos parcerias duradouras.",
      trade_volume: "Volume de Comércio Anual",
      partners: "Parceiros Globais",
      countries: "Países",
    },
    why_us: {
      tagline: "Por Que Nos Escolher",
      title: "Por Que Varyaz Trade",
      subtitle: "Sua porta para os mercados globais",
      quality: {
        title: "Garantia de Qualidade",
        description: "Todos os produtos passam por rigorosos controles de qualidade e possuem certificações internacionais"
      },
      global: {
        title: "Rede Global",
        description: "Conexões diretas com fornecedores e fabricantes em mais de 50 países"
      },
      logistics: {
        title: "Logística Perfeita",
        description: "Gestão da cadeia de suprimentos de ponta a ponta, da origem ao destino"
      },
      competitive: {
        title: "Preços Competitivos",
        description: "Poder de compra em massa garante as melhores taxas para nossos clientes"
      },
      support: {
        title: "Suporte 24/7",
        description: "Gerentes de conta dedicados disponíveis 24 horas"
      },
      docs: {
        title: "Documentação",
        description: "Documentação de exportação completa e assistência de conformidade"
      }
    },
    cta_section: {
      tagline: "Comece Sua Jornada",
      title: "Pronto para Adquirir Produtos de Qualidade Globalmente?",
      button: "Começar",
    },
    products: {
      title: "Nossas Categorias de Produtos",
      subtitle: "Explore nossa ampla gama de commodities comerciais",
      view_all: "Ver Todos",
      min_order: "Pedido Mín.",
      origin: "Origem",
      certifications: "Certificações",
      specifications: "Especificações",
      request_quote: "Solicitar Cotação",
      filter_all: "Todas as Categorias",
      search_placeholder: "Pesquisar produtos...",
      showing: "Mostrando",
      products_label: "produtos",
      in_category: "em",
      clear: "Limpar",
      no_products: "Nenhum produto encontrado",
      try_adjusting: "Tente ajustar sua pesquisa ou filtro",
      clear_all: "Limpar Todos os Filtros",
    },
    markets: {
      title: "Mercados de Commodities",
      subtitle: "Preços em tempo real e análise de mercado",
      tab_treemap: "Mapa",
      tab_calendar: "Calendário",
      tab_news: "Notícias",
      filter_all: "Todos",
      filter_grains: "Grãos",
      filter_energy: "Energia",
      filter_metals: "Metais",
      filter_industrial: "Industrial",
      refresh: "Atualizar",
      loading: "Carregando dados do mercado...",
      calendar_title: "Calendário Econômico - Próximos 7 Dias",
      calendar_subtitle: "Eventos de alto impacto que afetam os mercados de commodities",
      no_events: "Nenhum evento importante de commodities agendado",
      performance: "Desempenho",
      tile_size_note: "Tamanho = magnitude da mudança",
    },
    rfq: {
      title: "Solicitação de Cotação",
      subtitle: "Obtenha preços competitivos para pedidos em massa",
      get_pricing: "Obtenha Preços Competitivos",
      form: {
        product: "Nome do Produto",
        category: "Categoria",
        quantity: "Quantidade",
        unit: "Unidade",
        destination: "Porto de Destino",
        company: "Nome da Empresa",
        contact: "Pessoa de Contato",
        email: "Endereço de E-mail",
        phone: "Número de Telefone",
        message: "Requisitos Adicionais",
        submit: "Enviar Solicitação",
        success: "Sua solicitação foi enviada com sucesso!",
        error: "Algo deu errado. Por favor, tente novamente.",
      },
      units: {
        mt: "Toneladas Métricas",
        kg: "Quilogramas",
        units: "Unidades",
        containers: "Contêineres (20/40 pés)",
      }
    },
    about: {
      title: "Sobre Varyaz Trade",
      subtitle: "Sua Porta para os Mercados Globais",
      story: {
        title: "Nossa História",
        content: "Fundada com a visão de simplificar o comércio internacional, a Varyaz Trade cresceu para se tornar uma plataforma de comércio B2B confiável. Conectamos fornecedores, fabricantes e compradores em todos os continentes."
      },
      mission: {
        title: "Nossa Missão",
        content: "Facilitar o comércio global sem interrupções, garantindo preços competitivos para compradores e parcerias confiáveis para fornecedores."
      },
      vision: {
        title: "Nossa Visão",
        content: "Tornar-se a plataforma mais confiável do mundo para comércio de commodities B2B."
      },
      values: {
        title: "Nossos Valores",
        integrity: "Integridade",
        integrity_desc: "Negociações transparentes em cada transação",
        quality: "Qualidade",
        quality_desc: "Apenas produtos certificados entram em nosso catálogo",
        partnership: "Parceria",
        partnership_desc: "Relacionamentos de longo prazo acima de lucros rápidos",
        innovation: "Inovação",
        innovation_desc: "Abraçando a tecnologia para um comércio melhor"
      }
    },
    contact: {
      title: "Contate-nos",
      subtitle: "Entre em contato com nossa equipe",
      get_in_touch: "Entre em Contato",
      form: {
        name: "Seu Nome",
        email: "Endereço de E-mail",
        company: "Nome da Empresa",
        subject: "Assunto",
        message: "Sua Mensagem",
        submit: "Enviar Mensagem",
        success: "Mensagem enviada com sucesso!",
        error: "Falha ao enviar mensagem. Por favor, tente novamente.",
      },
      info: {
        address: "Endereço",
        address_value: "Global Trade Center, Dubai, EAU",
        phone: "Telefone",
        phone_value: "+971 4 123 4567",
        email: "E-mail",
        email_value: "info@varyaztrade.com",
        hours: "Horário Comercial",
        hours_value: "Seg - Sex: 9:00 - 18:00 (GST)",
      }
    },
    footer: {
      description: "Seu parceiro confiável em comércio B2B global. Conectando fornecedores a mercados em todo o mundo.",
      quick_links: "Links Rápidos",
      categories: "Categorias",
      contact: "Contato",
      newsletter: "Newsletter",
      newsletter_placeholder: "Digite seu e-mail",
      subscribe: "Inscrever-se",
      rights: "Todos os direitos reservados.",
      address: "Dnipro, Ucrânia",
      cta_title: "Pronto para Começar a Negociar?",
      cta_subtitle: "Obtenha preços competitivos para pedidos em grande quantidade",
      get_quote: "Obter Cotação",
      privacy: "Privacidade",
      terms: "Termos",
      cat_rice: "Arroz e Grãos",
      cat_steel: "Aço e Metais",
      cat_generators: "Geradores",
      cat_batteries: "Baterias",
      cat_tiles: "Pisos e Revestimentos",
    },
    common: {
      loading: "Carregando...",
      error: "Erro",
      back: "Voltar",
      learn_more: "Saiba Mais",
    },
    admin: {
      title: "Painel de Administração",
      analytics: "Análises",
      inquiries: "Consultas",
      total_visits: "Total de Visitas",
      page_views: "Visualizações de Página",
      rfq_submissions: "Solicitações de Cotação",
      contact_submissions: "Mensagens de Contato",
      recent_rfqs: "Solicitações Recentes",
      recent_contacts: "Mensagens Recentes",
      no_data: "Sem dados disponíveis",
      view_all: "Ver Todos",
      status: "Status",
      pending: "Pendente",
      responded: "Respondido",
      date: "Data",
      product: "Produto",
      company: "Empresa",
      email: "E-mail",
    }
  },
  // Japanese
  ja: {
    nav: {
      home: "ホーム",
      products: "製品",
      generators: "発電機",
      markets: "マーケット",
      about: "会社概要",
      contact: "お問い合わせ",
      rfq: "見積依頼",
    },
    hero: {
      tagline: "グローバル貿易ソリューション",
      title_line1: "あなたの",
      title_line2: "ゲートウェイ",
      title_line3: "世界市場へ",
      subtitle: "世界中の信頼できるソースから、農産物、建材、発電機、バッテリー、産業機器を提供",
      cta_primary: "製品を見る",
      cta_secondary: "見積を取得",
    },
    marquee: {
      quality: "プレミアム品質",
      network: "グローバルネットワーク",
      partners: "信頼できるパートナー",
      delivery: "迅速な配送",
    },
    stats: {
      countries: "対応国",
      products: "製品",
      partners: "取引パートナー",
      experience: "年の経験",
    },
    about_section: {
      tagline: "会社概要",
      title: "グローバル貿易へのゲートウェイ",
      description: "15年以上にわたり、Varyaz Tradeはグローバルサプライヤーと国際バイヤーを結ぶ架け橋となっています。農産物から建材、発電機から産業機械まで、私たちは単に製品を取引するだけでなく、永続的なパートナーシップを構築しています。",
      trade_volume: "年間取引量",
      partners: "グローバルパートナー",
      countries: "国",
    },
    why_us: {
      tagline: "選ばれる理由",
      title: "なぜVaryaz Tradeか",
      subtitle: "グローバル市場へのゲートウェイ",
      quality: {
        title: "品質保証",
        description: "すべての製品は厳格な品質チェックを受け、国際認証を取得"
      },
      global: {
        title: "グローバルネットワーク",
        description: "50カ国以上のサプライヤーとメーカーとの直接接続"
      },
      logistics: {
        title: "シームレスな物流",
        description: "原産地から目的地までのエンドツーエンドのサプライチェーン管理"
      },
      competitive: {
        title: "競争力のある価格",
        description: "大量購入力により、お客様に最高のレートを保証"
      },
      support: {
        title: "24時間サポート",
        description: "専任アカウントマネージャーが24時間対応"
      },
      docs: {
        title: "書類対応",
        description: "完全な輸出書類とコンプライアンス支援"
      }
    },
    cta_section: {
      tagline: "始めましょう",
      title: "グローバルに品質製品を調達する準備はできていますか？",
      button: "始める",
    },
    products: {
      title: "製品カテゴリ",
      subtitle: "取引商品の包括的な範囲をご覧ください",
      view_all: "すべて見る",
      min_order: "最小注文",
      origin: "原産地",
      certifications: "認証",
      specifications: "仕様",
      request_quote: "見積依頼",
      filter_all: "すべてのカテゴリ",
      search_placeholder: "製品を検索...",
      showing: "表示中",
      products_label: "製品",
      in_category: "カテゴリ",
      clear: "クリア",
      no_products: "製品が見つかりません",
      try_adjusting: "検索やフィルターを調整してみてください",
      clear_all: "すべてのフィルターをクリア",
    },
    markets: {
      title: "商品市場",
      subtitle: "リアルタイム価格と市場分析",
      tab_treemap: "ツリーマップ",
      tab_calendar: "カレンダー",
      tab_news: "ニュース",
      filter_all: "すべて",
      filter_grains: "穀物",
      filter_energy: "エネルギー",
      filter_metals: "金属",
      filter_industrial: "工業",
      refresh: "更新",
      loading: "市場データを読み込み中...",
      calendar_title: "経済カレンダー - 今後7日間",
      calendar_subtitle: "商品市場に影響を与える重要なイベント",
      no_events: "予定されている主要な商品イベントはありません",
      performance: "パフォーマンス",
      tile_size_note: "タイルサイズ = 変化の大きさ",
    },
    rfq: {
      title: "見積依頼",
      subtitle: "大量注文の競争力のある価格を取得",
      get_pricing: "競争力のある価格を取得",
      form: {
        product: "製品名",
        category: "カテゴリ",
        quantity: "数量",
        unit: "単位",
        destination: "仕向港",
        company: "会社名",
        contact: "担当者",
        email: "メールアドレス",
        phone: "電話番号",
        message: "追加要件",
        submit: "依頼を送信",
        success: "依頼が正常に送信されました！",
        error: "エラーが発生しました。もう一度お試しください。",
      },
      units: {
        mt: "メートルトン",
        kg: "キログラム",
        units: "ユニット",
        containers: "コンテナ (20/40フィート)",
      }
    },
    about: {
      title: "Varyaz Tradeについて",
      subtitle: "グローバル市場へのゲートウェイ",
      story: {
        title: "私たちのストーリー",
        content: "国際貿易を簡素化するビジョンで設立されたVaryaz Tradeは、信頼されるB2B取引プラットフォームに成長しました。大陸を越えてサプライヤー、メーカー、バイヤーを接続しています。"
      },
      mission: {
        title: "ミッション",
        content: "バイヤーには競争力のある価格を、サプライヤーには信頼できるパートナーシップを確保しながら、シームレスなグローバル貿易を促進すること。"
      },
      vision: {
        title: "ビジョン",
        content: "B2Bコモディティ取引において世界で最も信頼されるプラットフォームになること。"
      },
      values: {
        title: "価値観",
        integrity: "誠実さ",
        integrity_desc: "すべての取引において透明な対応",
        quality: "品質",
        quality_desc: "認証製品のみをカタログに掲載",
        partnership: "パートナーシップ",
        partnership_desc: "短期的な利益よりも長期的な関係を重視",
        innovation: "イノベーション",
        innovation_desc: "より良い取引のためにテクノロジーを活用"
      }
    },
    contact: {
      title: "お問い合わせ",
      subtitle: "チームにご連絡ください",
      get_in_touch: "お問い合わせ",
      form: {
        name: "お名前",
        email: "メールアドレス",
        company: "会社名",
        subject: "件名",
        message: "メッセージ",
        submit: "メッセージを送信",
        success: "メッセージが正常に送信されました！",
        error: "送信に失敗しました。もう一度お試しください。",
      },
      info: {
        address: "住所",
        address_value: "Global Trade Center, ドバイ, UAE",
        phone: "電話",
        phone_value: "+971 4 123 4567",
        email: "メール",
        email_value: "info@varyaztrade.com",
        hours: "営業時間",
        hours_value: "月〜金: 9:00 - 18:00 (GST)",
      }
    },
    footer: {
      description: "グローバルB2B取引の信頼できるパートナー。世界中のサプライヤーと市場を接続。",
      quick_links: "クイックリンク",
      categories: "カテゴリ",
      contact: "連絡先",
      newsletter: "ニュースレター",
      newsletter_placeholder: "メールアドレスを入力",
      subscribe: "購読する",
      rights: "全著作権所有。",
      address: "ドニプロ、ウクライナ",
      cta_title: "取引を始める準備はできていますか？",
      cta_subtitle: "大量注文の競争力のある価格を取得",
      get_quote: "見積もりを取得",
      privacy: "プライバシー",
      terms: "利用規約",
      cat_rice: "米と穀物",
      cat_steel: "鉄鋼と金属",
      cat_generators: "発電機",
      cat_batteries: "バッテリー",
      cat_tiles: "タイルと床材",
    },
    common: {
      loading: "読み込み中...",
      error: "エラー",
      back: "戻る",
      learn_more: "詳細を見る",
    },
    admin: {
      title: "管理ダッシュボード",
      analytics: "分析",
      inquiries: "問い合わせ",
      total_visits: "総訪問数",
      page_views: "ページビュー",
      rfq_submissions: "見積依頼",
      contact_submissions: "お問い合わせメッセージ",
      recent_rfqs: "最近の依頼",
      recent_contacts: "最近のメッセージ",
      no_data: "データがありません",
      view_all: "すべて見る",
      status: "ステータス",
      pending: "保留中",
      responded: "回答済み",
      date: "日付",
      product: "製品",
      company: "会社",
      email: "メール",
    }
  }
};

// Using country flag CDN images for better cross-platform compatibility
export const languages = [
  { code: "en", name: "English", flag: "https://flagcdn.com/w40/gb.png", dir: "ltr" },
  { code: "uk", name: "Українська", flag: "https://flagcdn.com/w40/ua.png", dir: "ltr" },
  { code: "tr", name: "Türkçe", flag: "https://flagcdn.com/w40/tr.png", dir: "ltr" },
  { code: "ar", name: "العربية", flag: "https://flagcdn.com/w40/sa.png", dir: "rtl" },
  { code: "zh", name: "中文", flag: "https://flagcdn.com/w40/cn.png", dir: "ltr" },
  { code: "fr", name: "Français", flag: "https://flagcdn.com/w40/fr.png", dir: "ltr" },
  { code: "pt", name: "Português", flag: "https://flagcdn.com/w40/br.png", dir: "ltr" },
  { code: "ja", name: "日本語", flag: "https://flagcdn.com/w40/jp.png", dir: "ltr" },
];
